import { IonButtons, IonToolbar, IonFooter } from "@ionic/react";
import NavToolBar from "./NavToolBar";

import "./MobileFooter.css";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface ContainerProps {}

const MobileFooter: React.FC<ContainerProps> = () => {
  return (
    <IonFooter className="mobile-footer">
      <IonToolbar>
        <IonButtons slot="end">
          <NavToolBar />
        </IonButtons>
      </IonToolbar>
    </IonFooter>
  );
};

export default MobileFooter;
